var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCoinVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1499_1383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FFCE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 27.0021C21.5133 27.0021 26.7936 21.7219 26.7936 15.2084C26.7936 8.69485 21.5133 3.41461 14.9998 3.41461C8.4863 3.41461 3.20605 8.69485 3.20605 15.2084C3.20605 21.7219 8.4863 27.0021 14.9998 27.0021Z",
    fill: "#F28A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.442 18.2269C16.442 17.7693 16.3289 17.4101 16.1033 17.15C15.8777 16.8892 15.4805 16.6432 14.9133 16.4117C14.3455 16.1803 13.8217 15.9459 13.3412 15.708C12.8607 15.4707 12.4465 15.1953 12.099 14.883C11.7516 14.5701 11.485 14.2086 11.2998 13.7973C11.1146 13.3859 11.0221 12.8879 11.0221 12.3031C11.0221 11.3246 11.352 10.5178 12.0123 9.88377C12.6727 9.24979 13.5527 8.88065 14.6531 8.77635V6.94354H16.0342V8.81092C17.0941 8.96737 17.9262 9.40331 18.5314 10.1182C19.1367 10.8336 19.4391 11.7412 19.4391 12.8416H16.5029C16.5029 12.2392 16.3869 11.7764 16.1555 11.4517C15.924 11.1277 15.5936 10.9654 15.1652 10.9654C14.7832 10.9654 14.4861 11.0855 14.2746 11.3258C14.0631 11.566 13.9576 11.8976 13.9576 12.3201C13.9576 12.7426 14.0795 13.0889 14.3227 13.3408C14.5658 13.5928 14.9566 13.833 15.4951 14.0615C16.0336 14.2906 16.5416 14.5279 17.0197 14.774C17.4973 15.0201 17.9104 15.2996 18.2578 15.6125C18.6053 15.9254 18.8771 16.2898 19.0746 16.707C19.2715 17.1242 19.3699 17.6252 19.3699 18.2099C19.3699 19.2002 19.0559 20.0082 18.4271 20.6334C17.7984 21.2586 16.943 21.6236 15.8602 21.7279V23.474H14.4791V21.7191C13.2164 21.5855 12.2479 21.1531 11.5734 20.4207C10.8984 19.6883 10.5615 18.7226 10.5615 17.5238H13.4889C13.4889 18.1842 13.6348 18.6863 13.9277 19.0308C14.2201 19.3754 14.6355 19.5476 15.174 19.5476C15.5678 19.5476 15.8777 19.4305 16.1033 19.1961C16.3289 18.9617 16.442 18.6389 16.442 18.2275V18.2269Z",
    fill: "#FFCE33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1499_1383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCoinVector);
export default __webpack_public_path__ + "static/media/dollar-coin-vector.e043daaf64c7ef63e17977ef349644d0.svg";
export { ForwardRef as ReactComponent };